var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHuluDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 50,
    viewBox: "11 8 118 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#292C33",
    d: "M84.566 54.801V9.337h11.427V54.8H84.566zm-17.854-13.16V22.975H77.71v19.595c0 7.207-4.118 12.173-10.997 12.173v.057H55.946c-7.468 0-12.52-4.22-12.52-12.23V22.976h10.996V41.64c0 1.654 1.317 2.991 2.946 2.991h6.398c1.629 0 2.946-1.337 2.946-2.99zm61.71-18.665h10.997v19.595c0 7.207-4.118 12.173-10.996 12.173v.057h-10.767c-7.468 0-12.52-4.22-12.52-12.23V22.976h10.998V41.64c0 1.654 1.317 2.991 2.946 2.991h6.397c1.628 0 2.945-1.337 2.945-2.99V22.975zm-106.657.548c6.96 0 12.518 3.199 12.518 11.511v19.766H23.286V36.456a2.939 2.939 0 0 0-2.945-2.937h-6.4a2.942 2.942 0 0 0-2.947 2.937V54.8H0V9.337h10.994v14.852s1.244-.665 3.717-.665h7.054z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuluDark);
export default __webpack_public_path__ + "static/media/hulu-dark.90ab1f9cbd50bba96c78fd39d3ba96b0.svg";
export { ForwardRef as ReactComponent };